import { apiOk } from './apiEnvelope';

const WEBHOOK_URL =
  (typeof process !== 'undefined' && process.env?.REACT_APP_AUTOMATION_WEBHOOK_URL) ||
  (typeof process !== 'undefined' && process.env?.REACT_APP_N8N_WEBHOOK_URL) ||
  '';

/**
 * Fire-and-forget POST to n8n / OpenClaw webhook. Never throws; resolves when the
 * request is accepted or skipped (no URL / offline).
 *
 * @param {string} event - e.g. 'user.signup', 'booking.created', 'payment.completed'
 * @param {object} payload - serializable event body (merged under `data` in the POST body)
 * @returns {Promise<void>}
 */
export async function sendToAutomation(event, payload = {}) {
  if (!WEBHOOK_URL || typeof fetch !== 'function') return;

  const body = apiOk(
    {
      event,
      ...payload,
      sentAt: new Date().toISOString(),
    },
    '',
  );

  try {
    await fetch(WEBHOOK_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
      keepalive: true,
    });
  } catch {
    // Intentionally swallow — automation must not break UX
  }
}
